"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyDisplay = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var jyEduStages_1 = require("../../model/jyEduStages");
var service_1 = require("../../../library/base/service");
var ApplyDisplay = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ApplyDisplay, _super);
    function ApplyDisplay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '课程分期申请接口';
        _this.code = '101098';
        _this.desc = '课程分期申请接口';
        _this.requestParams = new jyEduStages_1.ApplyDisplayRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ApplyDisplay;
}(service_1.BaseService));
exports.ApplyDisplay = ApplyDisplay;
//# sourceMappingURL=applyDisplay.js.map